import { Label, Pivot, PivotItem, Separator } from "@fluentui/react";
import { connect } from "react-redux";
import { withRouter } from "../../../commons/component/withRouterCustom";
import { useEffect, useState } from "react";

// styles
import './ContractDetail.Styles.css';

// functions
import * as ComponentFunctions from './ContractDetails.Functions';

//i18Next
import { useTranslation, Trans } from 'react-i18next';

// components
import CommissionAgentAssociatedComponent from "../../../components/Contracts/CommissionAgentAssociated/CommissionAgentAssociated.Component";
import AddendumsComponent from "../../../components/Contracts/Addendums/Addendums.List/Addendums.Components";
import ProtocolParactitionersListComponent from "../../../components/Protocols/Practitioners/PractitionerList/ProtocolPractitiones.List.Component";
import ContractCommissionAgentsComponent from "../../../components/Contracts/ContractCommissionAgents/ContractCommissionAgents.Component";
import StageListComponent from "../../../components/Contracts/Stages/StageList/StageList.Component";
import CycleListComponent from "../../../components/Contracts/Cycles/CycleList/CycleList.Component";
import ConceptListComponent from "../../../components/Contracts/Concept/ConceptList/ConceptList.Component";
import ConceptGroupedViewComponent from "../../../components/Contracts/Concept/ConceptGroupedView/ConceptGroupedView.Component";
// import BranchListComponent from "../../../components/Contracts/Branchs/BranchList/BranchList.Component";
import SettlementListComponent from "../../../components/Settlements/SettlementList/SettlementList.Component";
import ContractAssociationsComponent from "../../../components/Contracts/ContractAssociations/ContractAssociations.Component";
import { PageHeader } from "../../../commons/component/PageHeader/PageHeader";
import ContractHeaderComponent from "../../../components/Contracts/Header/ContractHeader.Component";
import ContractAccessListComponent from "../../../components/Contracts/Access/ContractAccess.List/ContractAccess.List.Component";
import FileUploadListComponent from "../../../components/Contracts/FileUpload/FileUploadList/FileUploadList.Component";
import ContractIAImportComponent from "../../../components/Contracts/ContractIAImport/Contract.IAImport.Component";
import ContractBillingControlComponent from "../../../components/Contracts/statistics/billing/ContractBillingControl.Component";

// models
import { ContractAddendum } from "../../../models/Entities/Contracts/ContractAddendum";
import BranchListComponent from "../../../components/Contracts/Branchs/BranchList/BranchList.Component";
import ContractNegotiationListComponent from "../../../components/ContractNegotiation/ContractNegotiationList/ContractNegotiationList.Component";
import { NegotiationConceptGridConnected } from "../../../components/ContractNegotiation";
import { AppsList20Regular, GroupList20Regular } from "@fluentui/react-icons";

const MAIN_TABS = ['visits', 'concepts', 'liquidations', 'statistics', 'medical-equipment'] as const;
type MainTabKey = typeof MAIN_TABS[number];
type ConceptViewMode = 'list' | 'grouped';

const normalizeMainTab = (value: string | null): MainTabKey => {
    if (value && (MAIN_TABS as readonly string[]).includes(value)) {
        return value as MainTabKey;
    }
    return 'visits';
};

const normalizeConceptView = (value: string | null): ConceptViewMode => {
    return value === 'grouped' ? 'grouped' : 'list';
};

const ContractDetailPage = (props: ComponentFunctions.Props) => {
    const locationSearch = ((props as any)?.location?.search as string | undefined) || '';

    // state
    const [SelectedAddendum, setSelectedAddendum] = useState<ContractAddendum | undefined>(undefined);
    const [selectedNegotiationId, setSelectedNegotiationId] = useState<string | undefined>(undefined);
    const [selectedMainTab, setSelectedMainTab] = useState<MainTabKey>('visits');
    const [conceptViewMode, setConceptViewModeState] = useState<ConceptViewMode>('list');

    //useTranslation()
    const [t] = useTranslation();

    useEffect(() => {
        props.GetContractById(props.ContractId);
        if (props.Contract) {
            props.GetContractAddendumsByContractId(props.ContractId);
        }
    }, [props.ContractId]);

    useEffect(() => {
        const params = new URLSearchParams(locationSearch);
        setSelectedMainTab(normalizeMainTab(params.get('tab')));
        setConceptViewModeState(normalizeConceptView(params.get('view')));
    }, [locationSearch]);

    const updateUrlParams = (next: { tab?: MainTabKey; view?: ConceptViewMode }) => {
        const params = new URLSearchParams(locationSearch);
        if (next.tab) {
            params.set('tab', next.tab);
        }
        if (next.view) {
            params.set('view', next.view);
        }
        const newSearch = params.toString();
        const nextUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}${window.location.hash || ''}`;
        window.history.replaceState(window.history.state, '', nextUrl);
    };

    useEffect(() => {
        if (SelectedAddendum?.contractAddendumType === 1) {
            return;
        }

        const enabledTabs: MainTabKey[] = ['visits', 'concepts', 'liquidations', 'statistics'];
        if (props.Protocol && props.Contract) {
            enabledTabs.push('medical-equipment');
        }

        if (!enabledTabs.includes(selectedMainTab)) {
            setSelectedMainTab('visits');
            updateUrlParams({ tab: 'visits' });
        }
        /* Ids instead of the objects: both are replaced by unrelated store updates. */
    }, [SelectedAddendum?.contractAddendumType, props.Protocol?.id, props.Contract?.id, selectedMainTab]);

    const handleMainTabChange = (item?: PivotItem) => {
        const key = (item as any)?.props?.itemKey as string | undefined;
        if (!key) {
            return;
        }
        const next = normalizeMainTab(key);
        setSelectedMainTab(next);
        updateUrlParams({ tab: next });
    };

    const setConceptViewMode = (mode: ConceptViewMode) => {
        setConceptViewModeState(mode);
        updateUrlParams({ view: mode });
    };

    // useEffect(() => {
    //     if (props.DefaultContractAddendum) {
    //         setSelectedAddendum(props.DefaultContractAddendum);
    //     }
    // }, [props.DefaultContractAddendum]);

    // useEffect(() => {
    //     if(SelectedAddendum) {
    //         props.GetAllContractsConcept(props.ContractId);
    //         props.GetAllContractCommissionConcepts(props.ContractId);
    //         props.GetAllContractsStage(props.ContractId, SelectedAddendum!.id);
    //     }
    // }, [SelectedAddendum]);

    return (
        <>
            <PageHeader title={t('contractDetailPage.contractDetailtitle')} />
            <ContractHeaderComponent ContractId={props.ContractId} />
            <div className="Section">
                <AddendumsComponent ContractId={props.ContractId} OnAddendumSelected={setSelectedAddendum} />
            </div>
            <div className="ContractPageContent">
                <div className="Section">
                    {SelectedAddendum?.contractAddendumType !== 1 &&
                        <Pivot selectedKey={selectedMainTab} onLinkClick={handleMainTabChange}>
                            <PivotItem itemKey='visits' headerText={t('contractDetailPage.contractDetailVisits')}>
                                <div className="VisitasSection">
                                    <div>
                                        {SelectedAddendum && <StageListComponent ContractId={props.ContractId} ContractAddendumId={SelectedAddendum?.id} />}
                                    </div>
                                    <div>
                                        <Label>{t('contractDetailPage.contractDetailCycles')}</Label>
                                        {SelectedAddendum && <CycleListComponent ContractId={props.ContractId} ContractAddendumId={SelectedAddendum?.id} />}
                                        <Separator />
                                        <Label>{t('contractDetailPage.contractDetailBranchs')}</Label>
                                        {SelectedAddendum && <BranchListComponent ContractId={props.ContractId} ContractAddendumId={SelectedAddendum.id} />}
                                    </div>
                                </div>
                            </PivotItem>
                            <PivotItem itemKey='concepts' headerText={t('contractDetailPage.contractDetailItem.conceptsSettled')}>
                                {SelectedAddendum && (
                                    <>
                                        <div className='ConceptViewBar' role='tablist' aria-label='Selector de vista de conceptos'>
                                            <button
                                                type='button'
                                                role='tab'
                                                aria-selected={conceptViewMode === 'list' ? 'true' : 'false'}
                                                className={`ConceptViewBarButton ${conceptViewMode === 'list' ? 'is-active' : ''}`}
                                                onClick={() => setConceptViewMode('list')}
                                            >
                                                <AppsList20Regular />
                                                <span>Lista</span>
                                            </button>
                                            <button
                                                type='button'
                                                role='tab'
                                                aria-selected={conceptViewMode === 'grouped' ? 'true' : 'false'}
                                                className={`ConceptViewBarButton ${conceptViewMode === 'grouped' ? 'is-active' : ''}`}
                                                onClick={() => setConceptViewMode('grouped')}
                                            >
                                                <GroupList20Regular />
                                                <span>Agrupada</span>
                                            </button>
                                        </div>

                                        <div className='ConceptViewContent'>
                                            {conceptViewMode === 'list' ? (
                                            <ConceptListComponent
                                                ContractId={props.ContractId}
                                                ContractAddendumId={SelectedAddendum?.id}
                                            />
                                            ) : (
                                            <ConceptGroupedViewComponent
                                                ContractId={props.ContractId}
                                                ContractAddendumId={SelectedAddendum?.id}
                                            />
                                            )}
                                        </div>
                                    </>
                                )}
                            </PivotItem>
                            <PivotItem itemKey='liquidations' headerText={t('contractDetailPage.contractDetailItem.liquidations')}>
                                <SettlementListComponent ContractId={props.ContractId} />
                            </PivotItem>
                            <PivotItem
                                itemKey='statistics'
                                headerText={t('contractDetailPage.contractDetailItem.statistics', 'Estadísticas')}
                                onRenderItemLink={() => (
                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                        {t('contractDetailPage.contractDetailItem.statistics', 'Estadísticas')}
                                        <span
                                            style={{
                                                fontSize: '0.6rem',
                                                fontWeight: 700,
                                                lineHeight: 1,
                                                padding: '2px 6px',
                                                borderRadius: 999,
                                                background: '#fef3c7',
                                                color: '#92400e',
                                                border: '1px solid #fcd34d',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.04em',
                                                verticalAlign: 'middle',
                                            }}
                                        >
                                            Preview
                                        </span>
                                    </span>
                                )}
                            >
                                <ContractBillingControlComponent
                                    ContractId={props.ContractId}
                                    SelectedAddendumId={SelectedAddendum?.id}
                                />
                            </PivotItem>
                            {props.Protocol && props.Contract && <PivotItem itemKey='medical-equipment' headerText={t('contractDetailPage.contractDetailItem.medicalEquipment')}>
                                <>
                                    {/* <h5>{t('contractDetailPage.contractDetailFeeDivision')}</h5> */}
                                    {/* <FeeDivisionContractComponent ContractId={props.Contract.id} /> */}
                                    {/* <Separator /> */}
                                    <ProtocolParactitionersListComponent showParticipation={(props.feeDivision || 0) === 0} ContractId={props.ContractId} ProtocolId={props.Protocol?.id} />

                                    {/* La solapa dejó de ser sólo el equipo médico: el contrato
                                        puede comisionar también a staff, proveedores y otros, que
                                        no participan del protocolo y por eso no aparecen arriba. */}
                                    <ContractCommissionAgentsComponent ContractId={props.ContractId} ProtocolId={props.Protocol?.id} />
                                    {/* <Pivot>
                                    <PivotItem headerText={t('contractDetailPage.contractDetailItem.financialParticipation')}>
                                        <ProtocolConceptMultiSelectorComponent
                                            concepts={props.ContractConcepts}
                                            selectedConceptIds={props.ContractCommissionConcepts?.map((contractCommissionConcept) => contractCommissionConcept.conceptId) || []}
                                            showPercentage={true}
                                            onAddConcept={AddConcept}
                                            onDeleteConcept={DeleteConcept}
                                        //onChangeParticipationPercentage={ChangeParticipationPercentage}
                                        //onCostParticipationActiveChange={ChangeCostParticipationActive}
                                        //onCostParticipationPercentageChange={ChangeCostParticipationPercentage}
                                        />
                                    </PivotItem>
                                    <PivotItem headerText={t('contractDetailPage.contractDetailItem.teamMembers')}>
                                       
                                    </PivotItem>
                                </Pivot> */}
                                </>
                            </PivotItem>}
                        </Pivot>
                    }
                    {SelectedAddendum?.contractAddendumType === 1 &&
                        <>
                            <ContractNegotiationListComponent
                                contractAddendumId={SelectedAddendum.id}
                                contractId={props.ContractId}
                                onNegotiationSelected={setSelectedNegotiationId}
                            />
                            {selectedNegotiationId && (
                                <>
                                    <Separator />
                                    <NegotiationConceptGridConnected
                                        contractId={props.ContractId}
                                        contractNegotiationId={selectedNegotiationId}
                                    />
                                </>
                            )}
                        </>
                    }

                </div>
                <div className="Section">

                    {props.ContractId && <FileUploadListComponent
                        ContractId={props.ContractId}
                        entityType="contract"
                        viewMode="list"
                    />}
                    <Separator />
                    <ContractIAImportComponent contractId={props.ContractId} />
                    <Separator />

                    {props.Contract && <ContractAccessListComponent ContractId={props.ContractId} />}
                    <Separator />
                    <ContractAssociationsComponent ContractId={props.ContractId} />
                    <CommissionAgentAssociatedComponent ContractId={props.ContractId} />
                </div>
            </div>

        </>);
}

export default withRouter(connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ContractDetailPage as any));